import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function AdminLoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back, Jason.");
      nav("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : Array.isArray(d) ? d.map(x => x.msg).join(" ") : "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="admin-app min-h-screen flex flex-col items-center justify-center px-6">
      <Link to="/" className="font-serif text-3xl text-white mb-2" data-testid="admin-login-logo">Fine Art by Jason</Link>
      <div className="overline text-white/40 mb-12">Studio Console</div>
      <form onSubmit={submit} className="w-full max-w-md space-y-5 surface p-10" data-testid="admin-login-form">
        <div>
          <label className="text-xs uppercase tracking-widest text-white/50">Email</label>
          <input required type="email" className="w-full mt-2 bg-black/40 border border-white/10 px-4 py-3 text-white outline-none focus:border-white/40 font-mono-brand"
            data-testid="admin-email" value={email} onChange={e => setEmail(e.target.value)} />
        </div>
        <div>
          <label className="text-xs uppercase tracking-widest text-white/50">Password</label>
          <input required type="password" className="w-full mt-2 bg-black/40 border border-white/10 px-4 py-3 text-white outline-none focus:border-white/40 font-mono-brand"
            data-testid="admin-password" value={password} onChange={e => setPassword(e.target.value)} />
        </div>
        <button type="submit" disabled={loading} data-testid="admin-login-submit"
          className="w-full bg-white text-black py-3 text-xs uppercase tracking-widest font-semibold hover:bg-white/90 disabled:opacity-50">
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
